import { createMuiTheme } from "@material-ui/core"

const theme = createMuiTheme({
	typography: {
		fontFamily: "'Open Sans', sans-serif",
		h6: {
			fontWeight: "700"
		},
		subtitle1: {
			color: "#666"
		},
		subtitle2: {
			color: "#666"
		},
		button: {
			fontWeight: "700",
			color: "#666"
		}
	},

	palette: {
		primary: {
			main: "#FF4949"
		},
		secondary: {
			main: "#56C568",
			contrastText: "#FFF"
		},
		info: {
			main: "#5BD1D7"
		}
	},

	overrides: {
		MuiTextField: {
			root: {
				width: "100%"
			}
		},
		MuiLink: {
			root: {
				color: "#1890FF",
				cursor: "pointer"
			}
		},
		MuiCircularProgress: {
			colorPrimary: {
				color: "#56C568"
			} 
		}
	}
})

export default theme
